import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { RestfulApiService } from '../restful-api.service';
import type { GeneralCountry } from '../general/general.service';

/** `userType` values the backend accepts; anything else returns `INVALID_USER_TYPE` */
export type ContactUsUserType = 'DONOR' | 'CHARITY';

export interface ContactUsInquiryPayload {
  name: string;
  email: string;
  userType: ContactUsUserType;
  /** The `{ uuid, name }` object from `/v1/general/dropdowns` `countries`, sent back as-is */
  country: GeneralCountry;
  /** An admin-configured support topic label, or "Other" */
  topic: string;
  message: string;
}

export interface ContactUsInquiryResponse {
  response: {
    uuid: string;
    creationDate: number;
  };
}

@Injectable({
  providedIn: 'root',
})
export class ContactUsService {
  private readonly api = inject(RestfulApiService);

  /**
   * Public contact-us form submission. Any non-2xx (400 validation error,
   * `INVALID_USER_TYPE`, `INVALID_COUNTRY_UUID`) has no field-level detail.
   */
  submitInquiry(payload: ContactUsInquiryPayload): Observable<ContactUsInquiryResponse> {
    return this.api.post(
      '/v1/contact-us/inquiries',
      payload
    ) as Observable<ContactUsInquiryResponse>;
  }
}
